module.exports = __webpack_public_path__ + "img/Standard View - 2.d6bf1c19.svg";